export default __webpack_public_path__ + "static/media/output.7c4f716b.mp3";